import { Button } from 'flowbite-react';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function HiringAssessmentEmptyState() {
	const navigate = useNavigate();
	return (
		<div className="px-20 w-full stretch mt-9">
			{/* Why Choose Section */}
			<section className="mb-14 text-[#1C1C28] w-full">
				<h2 className="text-3xl font-bold text-center mb-9 font-inter ">Why choose our assessment tests?</h2>
				<div className="grid md:grid-cols-3 gap-12">
					<div className="text-center">
						<div className="w-20 h-20 mx-auto mb-6">
							<img src="/assets/recruiterImages/createNewAssess.svg" alt="" />
						</div>
						<h3 className="text-xl font-semibold mb-4">
							Personalized
							<br />
							Adaptive Testing
						</h3>

						<p className="text-gray-600 max-w-[280px] mx-auto text-sm">
							Dynamic assessments tailored to each candidate's responses for a more accurate and personalized
							evaluation.
						</p>
					</div>

					<div className="text-center">
						<div className="w-20 h-20 mx-auto mb-6">
							<img src="/assets/recruiterImages/createNewAssessAI.svg" alt="" />
						</div>
						<h3 className="text-xl font-semibold mb-4">
							Comprehensive
							<br />
							Evaluation
						</h3>
						<p className="text-gray-600 max-w-[260px] mx-auto text-sm">
							Detailed insights with a rich question bank to thoroughly assess all required skills.
						</p>
					</div>

					<div className="text-center">
						<div className="w-20 h-20 mx-auto mb-6">
							<img src="/assets/recruiterImages/createNewAssess.svg" alt="" />
						</div>
						<h3 className="text-xl font-semibold mb-4">
							Secure and
							<br />
							Supervised
						</h3>
						<p className="text-gray-600 max-w-[240px] mx-auto text-sm">
							Proctored and monitored assessments to ensure integrity and fairness.
						</p>
					</div>
				</div>
			</section>

			{/* How it Works Section */}
			<section className="mb-10">
				<h2 className="text-3xl font-bold text-center mb-6">How it works</h2>
				<div className="flex flex-col md:flex-row justify-between items-center max-w-5xl mx-auto mb-14">
					<div className="flex flex-col items-center mb-8 md:mb-0">
						<div className="w-16 h-16 mb-4">
							<img src="/assets/recruiterImages/jobDetails.svg" alt="" />
						</div>
						<p className="text-sm font-medium text-center">
							Share Job
							<br />
							Details
						</p>
					</div>

					<div className="hidden md:block text-purple-400">
						<img src="/assets/recruiterImages/Line_1.png" alt="" />
					</div>

					<div className="flex flex-col items-center mb-8 md:mb-0">
						<div className="w-16 h-16 mb-4">
							<img src="/assets/recruiterImages/create&share.svg" alt="" />
						</div>
						<p className="text-sm font-medium text-center">
							Create & Share
							<br />
							Assessments
						</p>
					</div>

					<div className="hidden md:block text-purple-400">
						<img src="/assets/recruiterImages/Line_2.png" alt="" />
					</div>

					<div className="flex flex-col items-center mb-8 md:mb-0">
						<div className="w-16 h-16 mb-4">
							<img src="/assets/recruiterImages/assessCandidate.svg" alt="" />
						</div>
						<p className="text-sm font-medium text-center">
							Assess
							<br />
							Candidates
						</p>
					</div>

					<div className="hidden md:block text-purple-400">
						<img src="/assets/recruiterImages/Line_1.png" alt="" />
					</div>

					<div className="flex flex-col items-center mb-8 md:mb-0">
						<div className="w-16 h-16 mb-4">
							<img src="/assets/recruiterImages/selectCandidate.svg" alt="" />
						</div>
						<p className="text-sm font-medium text-center">
							Select
							<br />
							Candidates
						</p>
					</div>

					<div className="hidden md:block text-purple-400">
						<img src="/assets/recruiterImages/Line_2.png" alt="" />
					</div>

					<div className="flex flex-col items-center">
						<div className="w-16 h-16 mb-4">
							<img src="/assets/recruiterImages/hire&send.svg" alt="" />
						</div>
						<p className="text-sm font-medium text-center">
							Hire & Send
							<br />
							Offer
						</p>
					</div>
				</div>

				{/* Create Assessment Button */}
				<div className="text-center">
					<Button
						size="lg"
						className="whitespace-pre inline-flex items-center "
						color="purplePlaced"
						onClick={() => {
							navigate('/benchmarking/create-hiring-assessment');
						}}
					>
						<FaPlus className="mr-2" />
						Create New Assessment
					</Button>
				</div>
			</section>
		</div>
	);
}
